export const GET_COMPLETENESS_API_REQUEST = "GET_COMPLETENESS_API_REQUEST";
export const GET_COMPLETENESS_API_SUCCESS = "GET_COMPLETENESS_API_SUCCESS";
export const GET_COMPLETENESS_API_ERROR = "GET_COMPLETENESS_API_ERROR";